// extracted by mini-css-extract-plugin
export default {"OrganizationCard":"organization-card_OrganizationCard__K+-kM"};